import React, { useState, useEffect } from 'react'
import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Modal, Select } from '@material-ui/core';
import './style.css';
import Mobile from './Mobile';
import Desktop from './Desktop';

const ProductOptions = (props) => {
  const [detail, setDetail] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [cartridge, setCartridge] = useState('');
  const [quantity, setQuantity] = useState(1);
  const isMobile = props.isMobile;
  
  console.log("product-options-test", detail, cartridge, props.productType);
  useEffect(() => {
    if (props.product == '') {
      return;
    }
    setDetail(props.product);
  }, [props.product]);

  

  if (!detail) {
    return <></>
  }

  return (
    isMobile ? <Mobile {...props} /> : <Desktop  {...props} />
    );
}

export default ProductOptions;